const isUserLoggedIn = () => !!sessionStorage.getItem('token');

export default isUserLoggedIn;
